import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

const DomainContext = createContext(null);

export const useDomain = () => {
  const context = useContext(DomainContext);
  if (!context) {
    throw new Error("useDomain must be used within DomainProvider");
  }
  return context;
};

export const DomainProvider = ({ children }) => {
  const [domainInfo, setDomainInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCustomDomain, setIsCustomDomain] = useState(false);

  useEffect(() => {
    const resolveDomain = async () => {
      try {
        const hostname = window.location.hostname;
        
        // Skip resolution for localhost, preview URLs, and main domain
        const skipDomains = [
          "localhost",
          "127.0.0.1",
          "preview.emergentagent.com",
          "hospiceguard.com",
          "www.hospiceguard.com"
        ];
        
        const shouldSkip = skipDomains.some(d => 
          hostname === d || hostname.endsWith(`.${d}`)
        );
        
        if (shouldSkip) {
          setLoading(false);
          return;
        }
        
        // This is a custom domain - resolve it
        setIsCustomDomain(true);
        
        const response = await axios.get(`${API}/domains/resolve/${hostname}`);
        
        if (response.data?.found) {
          setDomainInfo(response.data);
          console.log("Custom domain resolved:", response.data);
        }
      } catch (error) {
        console.error("Failed to resolve domain:", error);
      } finally {
        setLoading(false);
      }
    };
    
    resolveDomain();
  }, []);

  return (
    <DomainContext.Provider value={{ 
      domainInfo, 
      loading, 
      isCustomDomain,
      companySlug: domainInfo?.slug,
      branding: domainInfo?.branding 
    }}>
      {children}
    </DomainContext.Provider>
  );
};

export default DomainProvider;
